/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { Document } from '../../core/models/Document';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';
import { Node } from '../../core/models/Node';

/**
 * A command used to replace a channel item with a newer version.
 * @author c.desc2@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceChannelItemCommand extends ReplaceNodeCommand<AaiChannelItem> {
    public _channelName : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>AaiChannelItem) || old === null) && ((replacement != null && replacement instanceof <any>AaiChannelItem) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._channelName===undefined) this._channelName = null;
            if(this._channelName===undefined) this._channelName = null;
            (() => {
                this._channelName = replacement.getName();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._channelName===undefined) this._channelName = null;
            if(this._channelName===undefined) this._channelName = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_models_AaiChannelItem(doc : Document, node : AaiChannelItem) {
        let aaiDocument : AaiDocument = <AaiDocument>doc;
        /* remove */(map => { let deleted = aaiDocument.channels[node.getName()];delete aaiDocument.channels[node.getName()];return deleted;})(aaiDocument.channels);
    }

    /**
     * @see ReplaceNodeCommand#removeNode(Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {AaiChannelItem} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>AaiChannelItem) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_models_AaiChannelItem(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_models_AaiChannelItem(doc : Document, node : AaiChannelItem) {
        let aaiDocument : AaiDocument = <AaiDocument>doc;
        node._ownerDocument = aaiDocument;
        node._parent = aaiDocument;
        /* put */(aaiDocument.channels[this._channelName] = node);
    }

    /**
     * @see ReplaceNodeCommand#addNode(Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {AaiChannelItem} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>AaiChannelItem) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_models_AaiChannelItem(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see ReplaceNodeCommand#readNode(Document, Object)
     * @param {Document} doc
     * @param {*} node
     * @return {AaiChannelItem}
     */
    readNode(doc : Document, node : any) : AaiChannelItem {
        let aaiDocument : AaiDocument = <AaiDocument>doc;
        let channelItem : AaiChannelItem = new Aai20NodeFactory().createChannelItem(aaiDocument, this._channelName);
        Library.readNode(node, channelItem);
        return channelItem;
    }
}
ReplaceChannelItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceChannelItemCommand";
ReplaceChannelItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




